<template>
    <div class="cumulative_income">
        <div class="cumulative_income_title">
            <p>累计收益图</p>

            <div class="distribution_chart_select" v-show="transactiontype === '2'">
                <p>择时选项 :</p>
                <select class="chary_select" v-model="selectedSignal" @click="charySelect">
                    <option :value="item" v-for="(item, key, index) in marketSignals" :key="key">{{ signalData[item] }}</option>
                </select>
            </div>
        </div>
        <cumulative-income
            :default-selected-day="defaultSelectedDay"
            :profitdata="currentProfitData"
            :dayselect="daySelect"
            :HSData="hsData">
        </cumulative-income>

    <div class="strategy_score">
        <p>策略得分
            <vue-notice-tip :list="noticeList"></vue-notice-tip>
        </p>
        <score :refresh="refresh" :scoreData="scoreData"></score>
    </div>
    <p class="ranking">该策略在广场上的排名</p>
    <div class="gradient">
        <p class="numranking" :style="{left: Math.max(-5, Math.min(295 - ((scoreData.rank + '').length*0.587 + 2) * 12, posileft * 290 - ((scoreData.rank + '').length*0.587 + 2) * 6))+ 'px',  whiteSpace: 'nowrap'}">第{{ scoreData.rank }}名</p>
        <span class="rankingtri" :style="{left: -5 + posileft * 290 + 'px'}"></span>
    </div>
</div>
</template>

<script>
    import cumulativeIncome from './cumulativeIncomeChart'
    import score from './scoreChart'
    export default {
        components: {
            'cumulative-income': cumulativeIncome,
            'score': score
        },
        data () {
            return {
                selectedSignal: '',
                detailContent: '',
                backtestContent: '',
                noticeList: [
                    '盈利能力：策略的盈亏比越大，该项分值越高；',
                    '选股能力：策略的成功率越大，该项分值越高；',
                    '抗风险能力：策略的回撤越小，该项分值越高；',
                    '稳定性：策略的波动越小，该项分值越高；',
                    '绝对收益：策略的年化收益率越大，该项分值越高。'
                ]
            }
        },
        props: {
            strategyId: String,
            // 回测id
            backtestId: {
                type: String,
                required: true
            },
            daySelect: {
                type: Array,
                required: true
            },
            profitData: [Array, Object],
            transactiontype: String,
            maxWinrate: Array,
            maxAnnualyield: Array,
            signalData: Object,
            refresh: Boolean,
            marketSignals: {
                type: Array,
                default: function () {
                    return []
                }
            },
            hsData: {
                type: Array,
                required: true
            },
            scoreData: {
                type: Object,
                required: true
            }
        },
        computed: {
            currentProfitData () {
                return this.transactiontype === '2' ? this.profitData[this.selectedSignal] : this.profitData
            },
            posileft () {
                return ((this.scoreData.count - this.scoreData.rank) / Math.max(1, (this.scoreData.count - 1)))
            },
            detailContentPoint () {
                return this.$buriedPoint.strategyDetails.profitChart
            },
            backtestContentPoint () {
                return this.$buriedPoint.strategyBacktest.profitChart
            },
            defaultSelectedDay () {
                let arr = []
                if (this.transactiontype === '2') {
                    if (this.selectedSignal === this.maxWinrate[1]) {
                        arr.push(this.maxWinrate[2])
                    }
                    if (this.selectedSignal === this.maxAnnualyield[1] && arr.indexOf(this.maxAnnualyield[2]) < 0) {
                        arr.push(this.maxAnnualyield[2])
                    }
                } else {
                    arr.push(this.maxWinrate[1])
                    if (this.maxWinrate[1] !== this.maxAnnualyield[1]) {
                        arr.push(this.maxAnnualyield[1])
                    }
                }
                return arr
            }
        },
        created () {
            this.init()
        },
        watch: {
            refresh () {
                this.init()
            },
            backtestId () {
                this.init()
            }
        },
        methods: {
            charySelect () {
                if (this.detailContent) {
                    window.TA.log(this.detailContentPoint.timingOption.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.backtestContentPoint.timingOption)
                }
            },
            init () {
                if (this.transactiontype === '2') {
                    this.selectedSignal = this.marketSignals[0]
                }
            }
        },
        mounted () {
            this.detailContent = document.getElementsByClassName('strategydetailmain')[0]
            this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0]
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategybacktest/cumulative_income.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/profit-chart.vue